var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.918 1.027C11.486.397 12.408 0 14.21 0h83.382c1.578 0 2.312.326 2.875.901.549.56.762 1.358.762 3.092v54.613c0 1.584-.23 2.227-.617 2.745a3.1 3.1 0 01-2.488 1.248h-84.8c-.962 0-1.82-.437-2.39-1.123-.447-.538-.626-1.229-.626-2.87V3.993c0-1.687.113-2.416.609-2.966z",
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#desktop_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.484 60.697c.566.007.893-.1 1.067-.31.159-.193.228-.509.228-1.041V3.302c0-1.952-.717-2.788-2.594-2.802H13.493c-2.044.016-2.835.66-2.835 2.491v55.755c0 1.337.364 1.963 1.166 1.95h87.66z",
    fill: "#323232"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.584 62.713c-.373-.14-.584-.508-.584-.906 0-.624.505-1.13 1.129-1.13h109.377c.625 0 1.131.507 1.131 1.132 0 .398-.209.765-.582.9-1.573.57-5.325 1.278-9.838 1.271-5.16-.007-44.515-.048-45.649-.05h-.05c-1.133.002-40.983.05-45.51.05-5.005 0-8.117-.774-9.424-1.267z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.637 60.678v1.751H0v-1.751h111.637z",
    fill: "#2C2C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.588 60.678H63.3c0 .438-.341 1.25-1.242 1.25H48.742c-.699 0-1.154-.812-1.154-1.25z",
    fill: "#262A2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.61 2.752h88.068v55.043H11.61V2.752z",
    fill: "#111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "desktop_svg__filter0_d",
    x: 10.158,
    y: 0,
    width: 91.12,
    height: 61.197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default SvgDesktop;